/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Defines the taxation status (tare or gross) to determine which prices need to be recomputed.
 */
export enum EnumTaxationMode {
    /**
     * Indicates that fixed prices are considered net prices, and the gross price should be computed.
     */
    PriceIsNet = 0,
    /**
     * Indicates that fixed prices are considered gross prices, and net prices should be computed.
     */
    PriceIsGross = 1,
}
